import { useEffect, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getRefreshStatus, getRefreshStatusRetryDelay } from 'api/lib/fetchImage'

export const useWaitForInvalidation = (
    invalidationId: string | undefined,
    options?: {
        onSuccess?: () => void
    },
) => {
    const { isSuccess, ...queryRest } = useQuery({
        queryKey: ['invalidation-status', invalidationId],
        queryFn: async () => {
            if (!invalidationId) {
                return
            }
            const { status } = await getRefreshStatus(invalidationId)
            if (status !== 'completed') {
                throw new Error('Invalidation not completed')
            }
            return status
        },
        retry: 8,
        retryDelay: (attempt) => getRefreshStatusRetryDelay(attempt),
        enabled: !!invalidationId,
    })

    const hasRunOnce = useRef(false)
    useEffect(() => {
        if (isSuccess && options?.onSuccess && !hasRunOnce.current) {
            options.onSuccess()
            hasRunOnce.current = true
        }
    }, [options, options?.onSuccess, isSuccess])

    return queryRest
}
